import { useTour } from '@reactour/tour';
import * as S from './tutorialContentBoxStyles';
import CloseIcon from '../../assets/icons/close_icon.svg';
import { FC, useContext } from 'react';
import {
  ILanguages,
  TranslationContext
} from '../../handlers/TranslationsHandler';

interface ITutorialContentBoxProps {
  title: ILanguages;
  text: ILanguages;
}

export const TutorialContentBox: FC<ITutorialContentBoxProps> = ({
  title,
  text
}) => {
  const { currentStep, setCurrentStep, steps, setIsOpen } = useTour();
  const { translate } = useContext(TranslationContext);

  return (
    <S.TutorialBoxContainer>
      {steps[currentStep].position === 'right' ? (
        <S.LeftArrow />
      ) : (
        <S.RightArrow />
      )}
      <S.TutorialBoxHeader>
        <S.TutorialTitle>{translate(title)}</S.TutorialTitle>
        <img src={CloseIcon} onClick={() => setIsOpen(false)} alt={'close'} />
      </S.TutorialBoxHeader>
      <S.TutorialText>{translate(text)}</S.TutorialText>
      <S.TutorialBoxFooter>
        <S.TutorialText>{`${translate('step')} ${currentStep + 1} ${translate(
          'from'
        )} ${steps.length}`}</S.TutorialText>
        <S.TutorialButton
          onClick={() => {
            setCurrentStep(currentStep < steps.length ? currentStep + 1 : 0);
          }}
        >
          {currentStep < steps.length - 1
            ? translate('further')
            : translate('end')}
        </S.TutorialButton>
      </S.TutorialBoxFooter>
    </S.TutorialBoxContainer>
  );
};
